module.exports = __webpack_public_path__ + "static/media/1010.6847cb8f.svg";